import * as React from 'react';

import { IInputChangeEventHandler } from '../../interfaces';
import Customer from '../../store/models/Customer';

interface IProps {
    customerId: string,
    customers: Customer[],
    handleChange: IInputChangeEventHandler,
}

export default class CustomerSelect extends React.Component<IProps, {}> {
    static propTypes = {
        customerId: React.PropTypes.string.isRequired,
        customers: React.PropTypes.array.isRequired,
        handleChange: React.PropTypes.func.isRequired,
    };

    render() {
        const {customerId, customers, handleChange} = this.props;

        return (
            <select style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px'}} className="form-control" name="customerId" value={customerId} onChange={(evt) => this.handleChange(evt)}>
                {customers.map((customer: Customer) => {
                    return <option key={customer.id} value={customer.id}>{customer.name}</option>;
                })}
            </select>
        );
    }

    handleChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const value: any = evt.target.value;
        this.props.handleChange('customerId', value);
    }
}


// WEBPACK FOOTER //
// ./src/components/reportSettings/CustomerSelect.tsx